import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select"; 
import Loader from "../Loader";
import { PROVIDER_POSITIONS } from "../enum";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const basicSchema = Yup.object().shape({
  plateNumber: Yup.string().required("Plate Number is required"),
  model: Yup.string().required("Vehicle Model is required"),
  color: Yup.string().required("Color is required"),
  driverId: Yup.mixed().required("Please select Driver").test(
    'is-valid-driver',
    'Driver ID must be a string or an array of strings',
    value => {
      // Check if value is an array of strings or a single string
      if (Array.isArray(value)) {
        return value.every(v => typeof v === 'string');  // All elements in array must be strings
      }
      return typeof value === 'string';  // Value must be a string if it's not an array
    }
  ),
  vehicleTypeProvider: Yup.number().required("Please select vehicle Type"),
  manufacturedYear: Yup.date()
    .nullable()
    .required("Manufactured Year is required")
    .max(new Date(), "Start Date must be earlier than today"),
  documents: Yup.mixed().required("Document is required"),
  vehicleImage: Yup.mixed().required("Image is required"),
  tradeLicence: Yup.mixed().required("Trade Licence is required"),
  insurance: Yup.mixed().required("Insurance is required"),
});

const Add = ({ showModal, hideModal, getVehicles }) => {
  const history = useNavigate();

  const [drivers, setDrivers] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedDriversId, setSelectedDriversId] = useState("");

  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const getDrivers = async () => {
    const response = await axios
      .get("/drivers")
      .then((res) => {
        setDrivers(res.data);
      })
      .catch((err) => {
        notifyError();
      });
  };

  const getVehicleTypes = async () => {
    const response = await axios
      .get("/vehicleTypes")
      .then((res) => {
        setVehicleTypes(res.data);
      })
      .catch((err) => {
        notifyError();
      });
  };
  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (typeof values.driverId === "string") {
      values.driverId = [values.driverId]; 
    }

    addVehicle(values);
    setLoading(true);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      plateNumber: "",
      model: "",
      color: "",
      vehicleImage: "",
      vehicleTypeProvider: 102,
      manufacturedYear: "",
      driverId: [],
      documents: "",
      tradeLicence: "",
      insurance: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () =>
    toast.success("Vehicle Added.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const addVehicle = async (e) => {
    const bodyFormData = new FormData();
    for (let value in values) {
      if (value === 'driverId' && Array.isArray(values[value])) {
        values[value].forEach((driverId) => {
          bodyFormData.append('driverId[]', driverId); 
        });
      } 
      else {
        bodyFormData.append(value, values[value]);
      }
    }
    const response = await axios
      .post("/vehicles", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        history("/vehicleList");
        setLoading(false);
        hideModal();
        getVehicles();
        notifySuccess();
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg(err.response.data.msg);
        notifyError();
      });
  };
  useEffect(() => {
    getVehicleTypes();
    getDrivers();
  }, []);
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
       style={{marginTop: "60px"}} 
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}

          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Plate Number</label>
                    <input
                      type="text"
                      name="plateNumber"
                      value={values.plateNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.plateNumber && touched.plateNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.plateNumber && touched.plateNumber && (
                      <p className="error">{errors.plateNumber}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Model</label>
                    <input
                      type="text"
                      name="model"
                      value={values.model}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.model && touched.model
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.model && touched.model && (
                      <p className="error">{errors.model}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Color</label>
                    <input
                      type="text"
                      id="inputName"
                      name="color"
                      value={values.color}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.color && touched.color
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.color && touched.color && (
                      <p className="error">{errors.color}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputEstimatedBudget">Manufactured Year</label>

                    <DatePickerField
                      name="manufacturedYear"
                      id="inputEstimatedBudget"
                      class="form-control"
                      value={values.manufacturedYear}
                      onChange={setFieldValue}
                      className={
                        errors.manufacturedYear && touched.manufacturedYear
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.manufacturedYear && touched.manufacturedYear && (
                      <p className="error">{errors.manufacturedYear}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label for="inputStatus">Vehicle Type</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="vehicleTypeProvider"
                      value={values.vehicleTypeProvider}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.vehicleTypeProvider && touched.vehicleTypeProvider
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Vehicle Type</option>
                      {vehicleTypes.map((vehicleType, index) => {
                        return (
                          <option key={vehicleType.id} value={vehicleType.id}>
                            {vehicleType.typeName}
                          </option>
                        );
                      })}
                    </select>
                    {errors.vehicleTypeProvider && touched.vehicleTypeProvider && (
                      <p className="error">{errors.vehicleTypeProvider}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card card-success">
                <div className="card-body">

                  {/* {
                    values.vehicleTypeId &&
                      <div className="form-group">
                          <label>Select Driver{values.vehicleTypeId === "13" ? "s" : ""}</label>
                          {values.vehicleTypeId === "13" ? (
                            // Multi-select for vehicleTypeId 13
                            <Select
                              isMulti
                              options={drivers.map((driver) => ({
                                value: driver.id.toString(), // Ensure the value is a string
                                label: `${driver.firstName} ${driver.lastName}`,
                              }))}
                              value={values.driverId.map((id) => ({
                                value: id.toString(), // Ensure the value is a string
                                label: drivers.find((driver) => driver.id === parseInt(id))?.firstName,
                              }))}
                              onChange={(selectedOptions) =>
                                setFieldValue(
                                  "driverId",
                                  selectedOptions ? selectedOptions.map((option) => option.value.toString()) : [] // Convert to string
                                )
                              }
                              className={errors.driverId && touched.driverId ? "form-control input-error" : "form-control "}
                            />
                          ) : (
                            // Single select for other vehicle types
                            <select
                              id="inputStatus"
                              name="driverId"
                              value={values.driverId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={errors.driverId && touched.driverId ? "form-control input-error custom-select" : "form-control custom-select"}
                            >
                              <option value="">Select Driver</option>
                              {drivers.map((driver) => (
                                <option key={driver.id} value={driver.id}>
                                  {driver.firstName} {driver.lastName}
                                </option>
                              ))}
                            </select>
                          )}
                          {errors.driverId && touched.driverId && <p className="error">{errors.driverId}</p>}
                      </div>
                  }
                  */}

                  {
                    values.vehicleTypeProvider && (
                      <div className="form-group">
                        <label>Select Driver{values.vehicleTypeProvider === PROVIDER_POSITIONS.AMBULANCE_PROVIDER ? "s" : ""}</label>
                        <Select
                          isMulti={values.vehicleTypeProvider === PROVIDER_POSITIONS.AMBULANCE_PROVIDER || "13" } // Multi-select for vehicleTypeId 13
                          options={drivers.map((driver) => ({
                            value: driver.id.toString(), // Ensure the value is a string
                            label: `${driver.firstName} ${driver.lastName}`,
                          }))}
                          value={
                            values.driverId ? (
                              Array.isArray(values.driverId)
                                ? values.driverId.map((id) => ({
                                    value: id.toString(),
                                    label: drivers.find((driver) => driver.id === parseInt(id))?.firstName,
                                  }))
                                : [
                                    {
                                      value: values.driverId.toString(),
                                      label: drivers.find((driver) => driver.id === parseInt(values.driverId))?.firstName,
                                    },
                                  ]
                            ) : [] // Default to an empty array if driverId is not defined
                          }
                          onChange={(selectedOptions) => {
                            if (values.vehicleTypeProvider === PROVIDER_POSITIONS.AMBULANCE_PROVIDER) {
                              setFieldValue(
                                "driverId",
                                selectedOptions ? selectedOptions.map((option) => option.value.toString()) : []
                              );
                            } else {
                              setFieldValue(
                                "driverId",
                                selectedOptions ? selectedOptions.value.toString() : ""
                              );
                            }
                          }
                        }
                        />
                        {errors.driverId && touched.driverId && <p className="error">{errors.driverId}</p>}
                      </div>
                    )
                  }



                  <div class="form-group">
                    <label for="exampleInputFile">Vehicle Image</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="vehicleImage"
                          accept="image/*"
                          onChange={(e) =>
                            setFieldValue(
                              "vehicleImage",
                              e.currentTarget.files[0]
                            )
                          }
                          className={
                            errors.vehicleImage && touched.vehicleImage
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.vehicleImage && touched.vehicleImage && (
                      <p className="error">{errors.vehicleImage}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Legal Documents</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="documents"
                          onChange={(event) => {
                            setFieldValue(
                              "documents",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          // id="inputName"
                          className={
                            errors.documents && touched.documents
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.documents && touched.documents && (
                      <p className="error">{errors.documents}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Trade Licence</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="tradeLicence"
                          onChange={(event) => {
                            setFieldValue(
                              "tradeLicence",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.tradeLicence && touched.tradeLicence
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.tradeLicence && touched.tradeLicence && (
                      <p className="error">{errors.tradeLicence}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Insurance</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="insurance"
                          onChange={(event) => {
                            setFieldValue(
                              "insurance",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.insurance && touched.insurance
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.insurance && touched.insurance && (
                      <p className="error">{errors.insurance}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {errorMsg && (
            <div>
              <h5 className="error">{errorMsg}</h5>
            </div>
          )}
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>
          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default Add;
